import { render } from "./index.vue?vue&type=template&id=361e5616&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=361e5616&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=361e5616&lang=scss"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361e5616"]])

export default __exports__